/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Section_CompanyInputs */

const en_company_registration_section_company = /** @type {(inputs: Company_Registration_Section_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Information`)
};

const de_company_registration_section_company = /** @type {(inputs: Company_Registration_Section_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abfrageformular`)
};

/**
* | output |
* | --- |
* | "Company Information" |
*
* @param {Company_Registration_Section_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_section_company = /** @type {((inputs?: Company_Registration_Section_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Section_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_section_company(inputs)
	return en_company_registration_section_company(inputs)
});